<template>
    <div class="history-list m-auto">
        <div v-if="isReward">
            <HistoryRewardItem
                    v-for="(campaign) in purchases"
                    :key="campaign.id"
                    :purchase="campaign"
                    @onClickPurchase="clickPurchase(campaign)"
            ></HistoryRewardItem>
        </div>
        <div v-else>
            <HistoryItem
                    v-for="(campaign) in purchases"
                    :key="campaign.id"
                    :purchase="campaign"
                    @onClickPurchase="clickPurchase(campaign)"
            ></HistoryItem>
        </div>
    </div>
</template>
<script>
import Account from '@/helper/AccountHelper.js';
import Util from '@/helper/Utility.js';
import Locale from '@/helper/locale/Locale.js';
import ConfigManager from '@/config/ConfigManager.js';
import { CampaignType } from '@/helper/StaticValue.js';
//component
import HistoryItem from './HistoryItem.vue';
import HistoryRewardItem from './HistoryRewardItem.vue';
//service
import BzbsHistory from '@/core/History/service/BzbsHistory.js';
import { SerialModel } from '@/core/Redeem/model/SerialModel.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import { StaticLevel,UserLevel } from "@/core/UserLevel/UserLevelDetail.js";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: 'HistoryList',
    mixins: [AuthStatusMixin,LocaleMixin],
    components: {
        HistoryItem,
        HistoryRewardItem
    },
    props: {
        initListConfig:     { type: Object, required: true },
        initFilterConfig:   { type: Object, required: true },
        isReward:           { type: Boolean, default: false},
        modalController:    { type: Object, required: true },
    },
    data: function() {
        return {
            listConfig: null,
            filterConfig: null,

            purchases: [],
            isLoading: false,
            isLoaded: false,
            isHaveItem: false,

            isSerialLoading: false,
        };
    },
    created: function() {
        this.listConfig = this.initListConfig;
        this.filterConfig = this.initFilterConfig;

        this.getList();
    },
    methods: {
        reinitList: function(listConfig, listFilter) {
            this.listConfig = listConfig;
            this.filterConfig = listFilter;
            this.purchases = [];
            this.getList();
        },
        //#region history list
        getList: function () {
            return new Promise((resolve) => {
                this.isLoading = true;
                BzbsHistory.apiGetPurchase(this.listConfig, this.filterConfig).subscribe((purchases) => {
                    Util.log('history list', purchases);

                    this.listConfig.increstSkip();
                    //check is there are more campaign.
                    if (purchases && purchases.length < this.listConfig.defaultTopAmount) {
                        this.listConfig.setSeeMoreEnable(false);
                    }
                    //reinitialize list if no skip.
                    if (this.listConfig.intSkip == this.listConfig.defaultTopAmount) {
                        this.purchases = [];
                    }

                    for (let purchase of purchases) {
                        //TODO: Add GA Tracking.
                        this.purchases.push(purchase);
                    }

                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = this.purchases.length > 0 ? true : false;
                    resolve();
                }, (err) => {
                    resolve();
                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.errorApi(err);
                });
            });
        },

        loadMore: async function() {
            console.log('load more list', this.listConfig.isSeeMoreEnable);
            if (!this.listConfig.isSeeMoreEnable || this.isLoading) {
                return;
            }
            this.modalController.loadingModal.show();
            await this.getList();
            this.modalController.loadingModal.hide();

        },
        //#endregion history list

        //#region action history
        clickPurchase: function (purchase) {
            if (this.isReward) {
                this.tracking.event('reward', 'click_campaign', purchase.id + '|' + purchase.name);
            } else {
                this.tracking.event('burn', 'click_see_code', purchase.id + '|' + purchase.name);
            }

            let level = this.getLevelText();
            if(this.isReward && !level) {
                this.modalController.confirmModal
                                    .clearModal()
                                    .setTag('verifiedlaserno')
                                    .setMsg(this.lbl.verify_laser_id.before_redeem)
                                    .setBtnOk(this.lbl.verify_laser_id.confirm_btn)
                                    .show()
                this.modalController.confirmModal.onClickOk(() => {
                    let url = `${ConfigManager.getWebSofinUrl()}/editinfo?return_url=${this.$route.path.substring(1,this.$route.path.length)}`
                    window.location.replace(url);
                });
                return;
            } else {
                //check internet stuff.
                if (this.isSerialLoading) {
                    return;
                }


                if (purchase.type === CampaignType.Interface) {
                    this.openInterfaceHistory(purchase);
                    return;
                }


                if (this.isShowSerialModal(purchase)) {
                    console.log(purchase);
                    if (purchase.isUsed) {
                        this.isSerialLoading = true;
                        BzbsHistory.apiRedeemDetail(purchase.redeemKey).subscribe((result) => {
                            this.isSerialLoading = false;
                            purchase.updateAfterRedeem(result);

                            if (this.isShowSerialModal(purchase)) {
                                this.openSerial(purchase);
                            }
                            // TODO ถ้ามีไรแปลกๆ ก็เปิด comment นี้ได้ (Chat)

                        }, (err) => {
                            this.isSerialLoading = false;
                            console.log(err);
                        });
                    } else {
                        this.openSerial(purchase);
                    }
                }
            }


            //check internet stuff.
            if (this.isSerialLoading) {
                return;
            }
            if (purchase.type === CampaignType.Interface) {
                this.openInterfaceHistory(purchase);
                return;
            }
            console.log(this.isShowSerialModal(purchase));
            if (this.isShowSerialModal(purchase)) {
                console.log(purchase);
                if (purchase.isUsed) {
                    this.isSerialLoading = true;
                    BzbsHistory.apiRedeemDetail(purchase.redeemKey).subscribe((result) => {
                        this.isSerialLoading = false;
                        purchase.updateAfterRedeem(result);

                        if (this.isShowSerialModal(purchase)) {
                            this.openSerial(purchase);
                        }
                        // TODO ถ้ามีไรแปลกๆ ก็เปิด comment นี้ได้ (Chat)

                    }, (err) => {
                        this.isSerialLoading = false;
                        console.log(err);
                    });
                } else {
                    this.openSerial(purchase);
                }
            }
        },

        openSerial: function(purchase) {
            let serialModel = new SerialModel();
            serialModel.setModelFromDataModel(purchase);

            console.log('open serial');
            this.modalController.serialModal
                    .clearModal()
                    .setIsFromHistory()
                    .setSerial(serialModel)
                    .show();
            this.modalController.serialModal.onSerialExpire(() => {
                purchase.setPurchaseExpired();
                this.refreshList();
            });
            this.modalController.serialModal.onClickUse(()=> {
                this.isSerialLoading = true;
                BzbsHistory.apiRedeemUse(purchase.redeemKey).subscribe((result) => {
                    this.isSerialLoading = false;

                    purchase.updateAfterRedeem(result);
                    purchase.setUse();
                    this.refreshList();

                    if (this.isShowSerialModal(purchase)) {
                        this.checkAfterUse(purchase);
                    }
                    // TODO ถ้ามีไรแปลกๆ ก็เปิด comment นี้ได้ (Chat)

                }, (err) => {
                    this.isSerialLoading = false;
                    console.log(err);
                });
            });
        },

        checkAfterUse: function(purchase) {
            let serial = new SerialModel();
            serial.setModelFromDataModel(purchase);

            if (serial.showTimer && serial.expireIn != 0) {
                this.openSerial(purchase);
            } else {
                this.modalController.serialModal.hide();
            }
        },

        openSerialNotUse: function(purchase) {
            let serialModel = new SerialModel();
            serialModel.setModelFromDataModel(purchase);

            console.log('open serial');
            this.modalController.serialModal
                    .clearModal()
                    .setIsFromHistory()
                    .setSerial(serialModel)
                    .show();
            this.modalController.serialModal.onSerialExpire(() => {
                purchase.setPurchaseExpired();
                this.refreshList();
            });
        },

        openInterfaceHistory: function(purchase) {
            let sToken = Account.getTokenShuffle();
            let locale = Locale.getLocaleCode();
            let header = 'false';
            let theme = ConfigManager.getAppName();
            let returnUrl = encodeURIComponent(window.location.href);

            // new generation landing interface
            if (purchase.privilegeMessageFormat == 'link') {
                let url = purchase.privilegeMessage;

                url = url.replace('<campaign_id>', purchase.id);
                url = url.replace('<token>', sToken);
                url = url.replace('<serial>', purchase.serial);
                url = url.replace('<locale>', Locale.getLocaleCode());

                url += '&return_url=' + returnUrl;

                window.location.replace(url);
                return;
            }

            // old default landing interface
            if (purchase.website && purchase.website.indexOf('starbucks') > 0) {
                let url = purchase.website +
                        '&token=' + sToken +
                        '&locale=' + locale +
                        '&RedeemKey=' + purchase.redeemKey +
                        '&header=' + header +
                        '&theme=' + theme +
                        '&return_url=' + returnUrl; // ReturnUrl;
                window.location.replace(url);
            } else if (purchase.website && purchase.website.indexOf('linesticker') > 0) {
                let url = purchase.website
                        + "&info2=" + purchase.info2
                        + "&info3=" + purchase.info3
                        + "&locale=" + locale
                        + "&return_url=" + encodeURIComponent(window.location.href)
                        + "&token=" + sToken
                        + "&is_history=true";
                window.location.replace(url);
            }
        },

        isShowSerialModal: function (purchase) {
            if (purchase.voucherExpireDate < purchase.currentDate) {
                return false;
            }

            if (purchase.type === CampaignType.Interface) {
                return purchase.pointType === "get" ? false : true;
            }

            console.log(purchase.type === CampaignType.Free ||
                purchase.type === CampaignType.Deal ||
                purchase.type === CampaignType.Buy ||
                purchase.type === CampaignType.Privilege2)

            if (purchase.type === CampaignType.Free ||
                purchase.type === CampaignType.Deal ||
                purchase.type === CampaignType.Buy ||
                purchase.type === CampaignType.Privilege2) {
                if (purchase.delivered) {
                    return false;
                }
            }

            if (purchase.type === CampaignType.Draw) {
                return false;
            } else {
                return true;
            }
        },

        refreshList: function () {
            let tmp = this.purchases;
            this.purchases = [];

            this.$nextTick().then( () => {
                this.purchases = tmp;
            });
        },
        //#endregion action history
        getLevelText: function () {
            if (this.isLogin) {
                this.level = {...StaticLevel};
                this.userLevel = new UserLevel();
                return this.userLevel.getLevelVerifiedlaserno();
            } else {
                return "";
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    .history-list {
        max-width: 500px;
    }
</style>
